module.exports = [() => ({
    restrict: 'AC',
    link(scope, elem, attrs = {}) {
        return setTimeout(() => elem.addClass('in'), attrs.delayMs || 0);
    }
})];
